import * as React from 'react';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { AutocompleteTextField } from '../../../components/Forms/fields';
import { DuplicateField, DeletionRule, DuplicateOptions } from './types';

interface Props {
    options: DuplicateOptions;
    onOptionsChange: (options: DuplicateOptions) => void;
}

const OptionsStep: React.FC<Props> = ({ options, onOptionsChange }) => {
    const t = useTranslations();

    const fieldOptions: { value: DuplicateField; label: string }[] = [
        { value: 'email', label: t(TK.email) },
        { value: 'phoneNumbers', label: t(TK.phoneNumbers) },
        { value: 'name', label: t(TK.name) },
        { value: 'identificationNumber', label: t(TK.identificationNumber) },
        { value: 'taxNumber', label: t(TK.taxNumber) },
        { value: 'healthNumber', label: t(TK.healthNumber) },
    ];

    const ruleOptions: { value: DeletionRule; label: string }[] = [
        { value: 'noEntities', label: t(TK.clearDuplicatesRuleNoEntities) },
        { value: 'fewerEntities', label: t(TK.clearDuplicatesRuleFewerEntities) },
    ];

    const fieldLabelToValue: Record<string, DuplicateField> = {};
    fieldOptions.forEach(o => { fieldLabelToValue[o.label] = o.value; });

    const ruleLabelToValue: Record<string, DeletionRule> = {};
    ruleOptions.forEach(o => { ruleLabelToValue[o.label] = o.value; });

    const currentFieldLabel = fieldOptions.find(o => o.value === options.field)?.label ?? '';
    const currentRuleLabel = ruleOptions.find(o => o.value === options.deletionRule)?.label ?? '';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacer-M)' }}>
            <AutocompleteTextField
                id='clear-duplicates-field'
                label={t(TK.clearDuplicatesByField)}
                options={fieldOptions.map(o => o.label)}
                value={currentFieldLabel}
                onValueChanged={label => {
                    const field = fieldLabelToValue[label ?? ''];
                    if (field) onOptionsChange({ ...options, field });
                }}
            />
            <AutocompleteTextField
                id='clear-duplicates-rule'
                label={t(TK.clearDuplicatesDeletionRule)}
                options={ruleOptions.map(o => o.label)}
                value={currentRuleLabel}
                onValueChanged={label => {
                    const rule = ruleLabelToValue[label ?? ''];
                    if (rule) onOptionsChange({ ...options, deletionRule: rule });
                }}
            />
        </div>
    );
};

export default OptionsStep;
